exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.card[data-v-3bfb0f00] {\n  max-height: 600px;\n}\n.card-content[data-v-3bfb0f00] {\n  max-height: 550px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-3bfb0f00","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/hrm-frontend/views/atomic/screen-components/purpose_components/common-components/AlertModal.vue
// module id = CBXo
// module chunks = 0